const config = {
    apiKey: "AIzaSyBl5qXfT_BrKjKaWY_yiWPzaIVicQa9FUQ",
    authDomain: "react-sequences.firebaseapp.com",
    databaseURL: "https://react-sequences.firebaseio.com",
    projectId: "react-sequences",
    storageBucket: "react-sequences.appspot.com",
    messagingSenderId: "654960058877",
    appId: "1:654960058877:web:3b04d3e4393af09ad8b994"
  }

export default config